//HDI View Type
export const HDI_VIEW_TYPE_USER = 'USER';
export const HDI_VIEW_TYPE_EDITOR = 'EDITOR';
export const HDI_VIEW_TYPE_ADMIN = 'ADMIN';
